<template>
    <div id="orgtree" v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" style="min-height: 680px;">
        
        <vue2-org-tree
            :data="treedatas"
            :horizontal="horizontal"
            :collapsable="collapsable"
            :label-class-name="labelClassName"
            :render-content="renderContent"
            :labelWidth="labelWidth"
            @on-node-click="onNodeClick"
            :style="{transform:scaleContainer.scaletrans}"

        />
        <div class="scale">
            <i class="el-icon-remove"  :class="scaleContainer.checkScalc==0?'fail':''" @click="reduceTrans"></i>
            <span class="percentage">{{scaleContainer.scalcArrPre[scaleContainer.checkScalc]}}</span>
            <i class="el-icon-circle-plus" :class="scaleContainer.checkScalc==2?'success':''" @click="addTrans"></i>
            <i class="el-icon-download" style="padding-left: 80px;cursor: pointer;font-size: 16px;" @click="generateImage"></i>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    export default {
        
        data:function(){
            return{
                loading: false,
                labelWidth:'100',
                treedatas: {
                    id: 0,
                    label: 'XXX科技有限公司',
                    children: [{
                        id: 2,
                        label: 'XXX科技有限公司XXX科',
                        children: [
                            {
                                id: 5,
                                label: '研发-前端',
                                img:require("@/assets/img/platform/pla_JD.png")
                            }, {
                                id: 6,
                                label: '研发-后端',
                                img:require("@/assets/img/platform/pla_JD.png")
                            }, {
                                id: 9,
                                label: 'UI设计'
                            }, {
                                id: 10,
                                label: '产品经理'
                            }]
                    }, {
                        id: 3,
                        label: '销售部',
                        children: [{
                            id: 7,
                            label: '销售一部'
                        }, {
                            id: 8,
                            label: '销售二部'
                        }]
                    }, {
                        id: 4,
                        label: '财务部'
                    }, {
                        id: 20,
                        label: 'HR人事'
                    }
                    ]
                },
                horizontal: true,
                collapsable: true,
                labelClassName: 'bg-white',
                tabPosition: 'left',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                scaleContainer:{
                    scaletrans:'scale(1)',
                    scalcArr:['scale(.8)','scale(.9)','scale(1)'],
                    scalcArrPre:['80%','90%','100%'],
                    checkScalc:2
                }
            }
        },
        mounted(){
            this.getDealerLevelShop()
        },
        methods: {
            // 生成图片
            generateImage() {
                const element = document.getElementById('orgtree'); // 替换为目标元素的id或class
                html2canvas(element).then((canvas) => {
                const image = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = image;
                link.download = 'image.png';
                link.click();
                });
            },
            ChineseToNumber(value) {
            if (value) {
                if (value == 1) {
                return value = '一级'
                }
                if (value == 2) {
                return value = '一级'
                }
                if (value == 3) {
                return value = '二级'
                }
                if (value == 4) {
                return value = '三级'
                }
                if (value == 5) {
                return value = '四级'
                }
                if (value == 6) {
                return value = '五级'
                }
                return value;
            }
            },
            noWang(value) {
            if (!value) {
                return value = " "
            } else {
                return value
            }
            },
            getDealerLevelShop(){
                this.loading = true
                //渠道总揽（经销商店铺关系总览）
                fetch({url: "hcm/hcmShop/getDealerLevelShop", method: "get"})
                    .then((res)=>{
                        if(res.status=='10000')this.treedatas=res.data
                        this.toggleExpand(res.data,true)//默认展开
                        this.loading = false
                    })
            },
            onNodeClick: function(e, data) {
                this.toggleExpand(data,!data.expand)
            },
            collapse: function(list) {
                var _this = this
                list.forEach(function(child) {
                    if (child.expand) {
                        child.expand = false
                    }
                    child.children && _this.collapse(child.children)
                })
            },
            renderContent: function(h, data) {
                let imgSrc = "";
                try {
                    imgSrc = require('@/assets/img/platform/pla_'+data.platform_code+'.png');
                } catch (err) {
                    imgSrc = "";
                }
                return h(
                    "el-popover", {attrs: {trigger: "hover", placement: "top"}},
                    [
                        h("div", {slot: "reference"},[
                            h('img',{attrs: {src:imgSrc}, class:'ptimg', style: { display:imgSrc ? 'block' : 'none' }}),
                            // h('div',{class:'levelDiv',style: { display:data.dealername ? 'block' : 'none' }},this.ChineseToNumber(data.level)),
                            h('div',{class:'levelDiv',style: { display:data.dealername ? 'block' : 'none' }},data.level),
                            h('span',{style:{color:'#108cee',fontSize:'12px'},attrs:{class:'toolEllipsis'}},data.name),
                        ]),
                        h("div", {style: "width: 300px",},[
                            h('div',{style: { display:data.dealername ? 'block' : 'none' }},"公司地址："+data.address),
                            h('div',{style: { display:data.dealername ? 'block' : 'none' }},"经销商联系人："+data.takepeople),
                            h('div',{style: { display:data.dealername ? 'block' : 'none' }},"经销商联系方式："+data.contact),
                            h('div',{style: { display:data.dealerid||data.platform_name ? 'block' : 'none' }},"平台："+data.platform_name),
                            h('div',{style: { display:data.dealerid||data.platform_name ? 'block' : 'none' }},"店铺名称："+data.shop_name),
                            h('div',{style: { display:data.dealerid||data.platform_name ? 'block' : 'none' }},"旺旺："+ this.noWang(data.wangwang)),
                            h('div',{class:'urlAddress',style: { display:data.dealerid||data.platform_name ? 'block' : 'none' }},
                            [
                                h('div', {style: {float: 'left' }}, '链接地址:'),
                                h('el-link',{ props: {href: data.shop_url},attrs: {target:"_blank"},style: {color: 'rgb(16, 140, 238)' }}, data.shop_url)
                            ])
                        ])
                    ]
                );
            },
            toggleExpand: function(data, val) {
                //展开收缩节点
                var _this = this
                if (Array.isArray(data)) {
                    data.forEach(function(item){
                        _this.$set(item, 'expand', val)
                        if (item.children) {
                            _this.toggleExpand(item.children, val)
                        }
                    })
                } else {
                    this.$set(data, 'expand', val)
                    if (data.children) {
                        _this.toggleExpand(data.children, val)
                    }
                }
            },
            reduceTrans(){
                if(this.scaleContainer.checkScalc>0) {
                    this.scaleContainer.checkScalc=this.scaleContainer.checkScalc-1
                    this.scaleContainer.scaletrans=this.scaleContainer.scalcArr[this.scaleContainer.checkScalc]
                }
            },
            addTrans(){
                if(this.scaleContainer.checkScalc<2) {
                    this.scaleContainer.checkScalc=this.scaleContainer.checkScalc+1
                    this.scaleContainer.scaletrans=this.scaleContainer.scalcArr[this.scaleContainer.checkScalc]
                }
            }
        },
    };
</script>

<style  lang="scss">
    @import '../../../../libs/org-tree.scss';
    .urlAddress {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    #orgtree{
        .toolEllipsis{
            max-width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
        }
        .div_content{
            align-items: center;
            display: flex;
        }
        .levelDiv {
          margin-right: 5px;
          // width: 41px;
          height: 20px;
          background-color: rgba(230, 247, 255, 1);
          box-sizing: border-box;
          border-width: 1px;
          border-style: solid;
          border-color: rgba(145, 213, 255, 1);
          border-radius: 4px;
          font-size: 12px;
          color: #1890FF;
          line-height: 18px;
        }

        .ptimg{
            width: 20px;
            height: 20px;
            margin-right: 12px;
        }
        .scale{
            position: absolute;
            right: 5%;
            bottom:0;
            z-index: 999;
            // font-size: 22px;
            color: #666;
            .percentage{
                padding: 0 25px;
            }
            .success{
                color: #999;
            }
            .fail{
                color: #d9d9d9;
            }
        }
        .el-popover__reference{
            display: flex;
            align-items: center;
        }
        .toolMain{
            position:absolute;
            top:-119px;
            left:-48px;
            display: none;
            height: 130px;
            min-width: 280px;
            background-image:url('../../../../assets/img/other/bubble.png');
            background-repeat: no-repeat;
            background-size: 100%;
            z-index: 555;
        }
        .org-tree-node:not(:first-child):before, .org-tree-node:not(:last-child):after,.horizontal .org-tree-node:not(:first-child):before, .horizontal .org-tree-node:not(:last-child):after
        ,.org-tree-node:not(:first-child):before, .org-tree-node:not(:last-child):after,.org-tree-node-children:before,.horizontal .org-tree-node-children:before
        {
            border-left: 1px solid #108cee;
        }
        .horizontal .org-tree-node:not(:only-child):after,.horizontal .org-tree-node-children:before{
            border-top: 1px solid #108cee;
        }
        .org-tree-node-label .org-tree-node-label-inner{
            box-shadow: 0 0 0 0 #fff;
            border:1px solid #108cee;
            padding: 8px!important;
            width: 100%;
        }
        .org-tree-node-label {
            white-space: nowrap;
        }
        .bg-white {
            background-color: white;
        }
        .bg-orange {
            background-color: orange;
        }
        .bg-gold {
            background-color: gold;
        }
        .bg-gray {
            background-color: gray;
        }
        .bg-lightpink {
            background-color: lightpink;
        }
        .bg-chocolate {
            background-color: chocolate;
        }
        .bg-tomato {
            background-color: tomato;
        }
    }
</style>
